<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2>{{ $t('_bqyy._bqyy') }}</h2>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <div class="sobx">{{ $t('_bqyy._qrbq') }}</div>

      <div class="reservation-form">
        <div class="form-actions">
          <button type="button" class="cancel-btn" @click="$emit('close')">{{ $t('_bqyy._qx') }}</button>
          <button type="submit" class="submit-btn1" @click="handleSubmit">{{ $t('_bqyy._tjyy') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReservationForm',
  data() {
    return {
      formData: {
        name: '',
        phone: '',
      }
    }
  },
  methods: {
    closeModal(e) {
      if (e.target.classList.contains('modal-overlay')) {
        this.$emit('close')
      }
    },
    handleSubmit() {
      this.$emit('submit', this.formData)
    }
  }
}
</script>

<style scoped>
/* ===== 深色主题弹窗 ===== */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10003;
  padding: 20px;
  backdrop-filter: blur(8px);
}

.modal-content {
  background: #1a1f26;
  border-radius: 15px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  border: 1px solid #2a3038;
}

/* 隐藏滚动条 */
.modal-content::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.modal-content {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #2a3038;
}

.modal-header h2 {
  color: #e8edf2;
  margin: 0;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #6a7a8a;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #e8edf2;
}

.sobx {
  padding: 30px 30px 0 30px;
  color: #b0bcc8;
  font-size: 15px;
  line-height: 1.6;
}

.reservation-form {
  padding: 30px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #e8edf2;
  font-weight: 600;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  background: #0a0d0f;
  border: 1.5px solid #2a3038;
  border-radius: 8px;
  font-size: 1rem;
  color: #e8edf2;
  transition: border-color 0.3s ease;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #4a5662;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #ffb300;
  box-shadow: 0 0 0 4px rgba(255, 179, 0, 0.06);
}

.form-actions {
  display: flex;
  gap: 15px;
}

.cancel-btn,
.submit-btn1 {
  flex: 1;
  padding: 15px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}

.cancel-btn {
  background: #2a3038;
  color: #8a949f;
}

.cancel-btn:hover {
  background: #3a4652;
  color: #e8edf2;
}

.submit-btn1 {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
}

.submit-btn1:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(255, 179, 0, 0.25);
}
</style>